import React, { memo } from 'react';
import './PowerGrid.scss';

const excludedPrescText = ['Call Me/Email Me for Power', 'Call Me/Email Me for Color', ''];

function excludePrescValues(prescValue, hyphenSybmol) {
    if (excludedPrescText.includes(prescValue) || !prescValue) return hyphenSybmol;
    return prescValue;
}

function PowerGrid(props) {
    const { prescription: { left, right, userName, labels }, view, dataLocale = {} } = props;
    const { YOUR_POWER, HYPHEN, LEFT, RIGHT } = dataLocale;
    let itemPrescriptions;
    if (left && Object.keys(left).length) {
        itemPrescriptions = left;
    } else if (right && Object.keys(right).length) {
        itemPrescriptions = right;
    }
    let userTitle = userName || YOUR_POWER;
    if (userTitle.toLowerCase() === 'user') {
        userTitle = YOUR_POWER;
    }

    return (
        <div data-testid="powerTableBlock" className={`power-table-block ${view === 'desktop' ? 'desktop bora-8 margin-l15 margin-r15 margin-b10 margin-b10 padding-0' : 'shadow bora-4 mr-auto'}`}>
            <div className={`name-strip ${view === 'desktop' ? 'fs12 padding-t10 margin-b5 padding-l15' : 'pd-b10 mr-b5 pd-t10'}`}><span className={`fw700 inline-block ${view === 'desktop' ? 'padding-b5 margin-l15' : 'mr-l15'}`}>{userTitle}</span></div>
            <div className={`${view === 'desktop' ? 'padding-t5 fs12 padding-l15 padding-r15' : 'text-color_grey_black bg-color_white'}`}>
                <div className={`power-item ${view === 'desktop' ? 'display-flex justify-content-end padding-b10' : 'pd-b10'}`}>
                    <div className={`fw700 ${view === 'desktop' ? 'padding-t20 flex-1 display-flex flex-column' : 'text-right'}`}>
                        {left && <div className={`${view === 'desktop' ? 'width25' : 'pull-right mr-l10 w16vw'}`}>{LEFT}</div>}
                        {right && <div className={`${view === 'desktop' ? 'width25' : 'pull-right w16vw'}`}>{RIGHT}</div>}
                    </div>
                    {itemPrescriptions && Object.keys(itemPrescriptions).map(keys => {
                        if ((left && left[keys] && excludedPrescText.includes(left[keys])) && (right && right[keys] && excludedPrescText.includes(right[keys])) ||
                            (left && !left[keys]) && (right && !right[keys]) ||
                            (!left || !left[keys]) && (!right || !right[keys])) {
                            return null;
                        }
                        return (
                            <div data-testid="powerBlock" className={`overflow-hidden ${view === 'desktop' ? 'full-width text-right flex-basis-20 display-flex flex-column' : 'w100'}`} key={`#left_${keys}`}>
                                <div className={`fw700 float-left ${view === 'desktop' ? 'width100 pull-right fs12' : 'w40vw fsp12'}`}>{labels[keys]}</div>
                                {left && <div data-testid="prescValues" className={`text-right ${view === 'desktop' ? 'width100' : 'pull-right w16vw mr-l10'}`}>{excludePrescValues(left[keys], HYPHEN)}</div>}
                                {right && <div data-testid="prescValues" className={`text-right ${view === 'desktop' ? 'width100' : 'pull-right w16vw'}`}>{excludePrescValues(right[keys], HYPHEN)}</div>}
                            </div>
                        );
                    })}
                </div>
            </div>
        </div>
    );
}

export default memo(PowerGrid);
